import { v4 as uuid } from "uuid";

export const hasLocalStorage = function() {
    const item = uuid();
    try {
        window.localStorage.setItem(item, item);
        if (window.localStorage.getItem(item) !== item) {
            throw new Error("localStorage.getItem does not return expected value");
        }
        window.localStorage.removeItem(item);
        return true;
    } catch {
        return false;
    }
};
